import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `open_queries/organization/basic_production/process/${organization_id}/harvest_process/${harvest_process_id}`
    );
  },
  fetchHarvestedBatches(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `open_queries/organization/basic_production/process/${organization_id}/harvested_batches/${harvest_process_id}`
    );
  }
};
